import { render, staticRenderFns } from "./a-generando-archivo.vue?vue&type=template&id=675d6047&scoped=true&"
import script from "./a-generando-archivo.vue?vue&type=script&lang=ts&"
export * from "./a-generando-archivo.vue?vue&type=script&lang=ts&"
import style0 from "./a-generando-archivo.vue?vue&type=style&index=0&id=675d6047&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675d6047",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressLinear,VRow})
